<template>
  <section class="tw-flex tw-gap-3">
    <div
      v-for="i in totalIndex"
      :key="i"
      :class="[
        'tw-cursor-pointer',
        'tw-w-[64px] tw-h-[6px] tw-rounded-[14px]', 
        'tw-bg-ap-gainsboro',
        { '!tw-bg-ap-dodger-blue': i <= activeIndex }
      ]" 
      @click="onClickProgressBar(i)"
    />
  </section>
</template>

<script setup lang="ts">

const props = defineProps < {
  activeIndex: number
  totalIndex: number
} > ();

const emit = defineEmits(['update:activeIndex']);
function onClickProgressBar(index: number){
  if (index >= props.activeIndex) return;
  emit('update:activeIndex', index);
}

</script>

<style scoped>
</style>